import { Box, Typography } from "@mui/material";
import ValidationItem from "./ValidationItem";

interface PasswordRequirementsProps {
  password: string;
}

const PasswordRequirements = ({ password }: PasswordRequirementsProps) => {
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
  const hasMinLength = password.length >= 8;

  return (
    <Box
      sx={{
        padding: "10px",
      }}
    >
      <Typography variant="body3" color={"common.black"} fontWeight={600}>
        Password Requirements:
      </Typography>
      <br />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "5px",
          padding: "0 0 0 5px",
        }}
        mt={3}
      >
        <ValidationItem isValid={hasMinLength} text="At least 8 characters" />
        <ValidationItem
          isValid={hasUppercase}
          text="One uppercase letter (A-Z)"
        />
        <ValidationItem
          isValid={hasLowercase}
          text="One lowercase letter (a-z)"
        />
        <ValidationItem isValid={hasNumber} text="One number (0-9)" />
        <ValidationItem
          isValid={hasSpecialChar}
          text="One special character (!@#$%^&*)"
        />
      </Box>
    </Box>
  );
};

export default PasswordRequirements;
